//============ fixf.core.services.organization.ResidentsCommitteeQueryPara =============
/* eslint-disable camelcase */
import {
  QueryParameter
} from '@/base/QueryParameter';

export class ResidentsCommitteeQueryPara extends QueryParameter {
  constructor() {
    super();
  }

  _QueryAttr_OrgCode = 'orgCode';
  _QueryAttr_OrgName = 'orgName';
  _QueryAttr_CantonCode = 'cantonCode';
  _QueryAttr_OrgCodeValidTime = 'orgCodeValidTime';
  _QueryAttr_ContactPerson = 'contactPerson';
  _QueryAttr_ContactTel = 'contactTel';
  _QueryAttr_OfficePhone = 'officePhone';
  _QueryAttr_FaxNumber = 'faxNumber';
  _QueryAttr_ZipCode = 'zipCode';
  _QueryAttr_Email = 'email';
  _QueryAttr_CreateDate = 'createDate';
  _QueryAttr_IsDelete = 'isDelete';
  _QueryAttr_Address = 'address';
  _QueryAttr_OrgCodeFileID = 'orgCodeFileID';
  _QueryAttr_ThreeInOne = 'threeInOne';
  _QueryAttr_IsAuthen = 'isAuthen';
  _QueryAttr_MasterName = 'masterName';
  _QueryAttr_MasterTel = 'masterTel';
  _QueryAttr_MasterIdentity = 'masterIdentity';
  _QueryAttr_Tenure = 'tenure';
  _QueryAttr_FoundedTime = 'foundedTime';
  _QueryAttr_ExpirationTime = 'expirationTime';
  _QueryAttr_DeputyDirectorName = 'deputyDirectorName';
  _QueryAttr_StreetOfficeCode = 'streetOfficeCode';
  _OrderAttr_OrgCode = 'OrgCode';
  _OrderAttr_OrgName = 'OrgName';
  _OrderAttr_CantonCode = 'CantonCode';
  _OrderAttr_OrgCodeValidTime = 'OrgCodeValidTime';
  _OrderAttr_ContactPerson = 'ContactPerson';
  _OrderAttr_ContactTel = 'ContactTel';
  _OrderAttr_OfficePhone = 'OfficePhone';
  _OrderAttr_FaxNumber = 'FaxNumber';
  _OrderAttr_ZipCode = 'ZipCode';
  _OrderAttr_Email = 'Email';
  _OrderAttr_CreateDate = 'CreateDate';
  _OrderAttr_IsDelete = 'IsDelete';
  _OrderAttr_Address = 'Address';
  _OrderAttr_OrgCodeFileID = 'OrgCodeFileID';
  _OrderAttr_ThreeInOne = 'ThreeInOne';
  _OrderAttr_IsAuthen = 'IsAuthen';
  _OrderAttr_MasterName = 'MasterName';
  _OrderAttr_MasterTel = 'MasterTel';
  _OrderAttr_MasterIdentity = 'MasterIdentity';
  _OrderAttr_Tenure = 'Tenure';
  _OrderAttr_FoundedTime = 'FoundedTime';
  _OrderAttr_ExpirationTime = 'ExpirationTime';
  _OrderAttr_DeputyDirectorName = 'DeputyDirectorName';
  _OrderAttr_StreetOfficeCode = 'StreetOfficeCode';


  /*addresss:String[]*/
  setParamByAddress_Enum(addresss) {
    this.addParameterByEnum(this._QueryAttr_Address, addresss);
  }

  /*address:String*/
  setParamByAddress(address) {
    this.addParameter(this._QueryAttr_Address, address);
  }

  /*deputyDirectorNames:String[]*/
  setParamByDeputyDirectorName_Enum(deputyDirectorNames) {
    this.addParameterByEnum(this._QueryAttr_DeputyDirectorName, deputyDirectorNames);
  }

  /*cantonCode:String*/
  setParamByCantonCode(cantonCode) {
    this.addParameter(this._QueryAttr_CantonCode, cantonCode);
  }

  /*orgName:String*/
  setParamByOrgName(orgName) {
    this.addParameter(this._QueryAttr_OrgName, orgName);
  }

  /*startDate:Date, endDate:Date*/
  setParamByCreateDate_Range(startDate, endDate) {
    this.addDateParameterByRange(this._QueryAttr_CreateDate, startDate, endDate);
  }

  /*streetOfficeCode:String*/
  setParamByStreetOfficeCode(streetOfficeCode) {
    this.addParameter(this._QueryAttr_StreetOfficeCode, streetOfficeCode);
  }

  /*isDelete:boolean*/
  setParamByIsDelete(isDelete) {
    this.addParameter(this._QueryAttr_IsDelete, isDelete);
  }

  /*cantonCodes:String[]*/
  setParamByCantonCode_Enum(cantonCodes) {
    this.addParameterByEnum(this._QueryAttr_CantonCode, cantonCodes);
  }

  /*orgCode:String*/
  setParamByOrgCode(orgCode) {
    this.addParameter(this._QueryAttr_OrgCode, orgCode);
  }

  /*isAuthen:boolean*/
  setParamByIsAuthen(isAuthen) {
    this.addParameter(this._QueryAttr_IsAuthen, isAuthen);
  }

  /*orgCodes:String[]*/
  setParamByOrgCode_Enum(orgCodes) {
    this.addParameterByEnum(this._QueryAttr_OrgCode, orgCodes);
  }

  /*tenure:String*/
  setParamByTenure(tenure) {
    this.addParameter(this._QueryAttr_Tenure, tenure);
  }

  /*email:String*/
  setParamByEmail(email) {
    this.addParameter(this._QueryAttr_Email, email);
  }

  /*createDate:Date*/
  setParamByCreateDate(createDate) {
    this.addParameter(this._QueryAttr_CreateDate, createDate);
  }

  /*zipCodes:String[]*/
  setParamByZipCode_Enum(zipCodes) {
    this.addParameterByEnum(this._QueryAttr_ZipCode, zipCodes);
  }

  /*orgCodeFileIDs:String[]*/
  setParamByOrgCodeFileID_Enum(orgCodeFileIDs) {
    this.addParameterByEnum(this._QueryAttr_OrgCodeFileID, orgCodeFileIDs);
  }

  /*orgNames:String[]*/
  setParamByOrgName_Enum(orgNames) {
    this.addParameterByEnum(this._QueryAttr_OrgName, orgNames);
  }

  /*contactTels:String[]*/
  setParamByContactTel_Enum(contactTels) {
    this.addParameterByEnum(this._QueryAttr_ContactTel, contactTels);
  }

  /*threeInOne:boolean*/
  setParamByThreeInOne(threeInOne) {
    this.addParameter(this._QueryAttr_ThreeInOne, threeInOne);
  }

  /*emails:String[]*/
  setParamByEmail_Enum(emails) {
    this.addParameterByEnum(this._QueryAttr_Email, emails);
  }

  /*masterNames:String[]*/
  setParamByMasterName_Enum(masterNames) {
    this.addParameterByEnum(this._QueryAttr_MasterName, masterNames);
  }

  /*contactPerson:String*/
  setParamByContactPerson(contactPerson) {
    this.addParameter(this._QueryAttr_ContactPerson, contactPerson);
  }

  /*faxNumber:String*/
  setParamByFaxNumber(faxNumber) {
    this.addParameter(this._QueryAttr_FaxNumber, faxNumber);
  }

  /*orgCodeFileID:String*/
  setParamByOrgCodeFileID(orgCodeFileID) {
    this.addParameter(this._QueryAttr_OrgCodeFileID, orgCodeFileID);
  }

  /*contactPersons:String[]*/
  setParamByContactPerson_Enum(contactPersons) {
    this.addParameterByEnum(this._QueryAttr_ContactPerson, contactPersons);
  }

  /*startDate:Date, endDate:Date*/
  setParamByOrgCodeValidTime_Range(startDate, endDate) {
    this.addDateParameterByRange(this._QueryAttr_OrgCodeValidTime, startDate, endDate);
  }

  /*masterName:String*/
  setParamByMasterName(masterName) {
    this.addParameter(this._QueryAttr_MasterName, masterName);
  }

  /*orgCodeValidTime:Date*/
  setParamByOrgCodeValidTime(orgCodeValidTime) {
    this.addParameter(this._QueryAttr_OrgCodeValidTime, orgCodeValidTime);
  }

  /*contactTel:String*/
  setParamByContactTel(contactTel) {
    this.addParameter(this._QueryAttr_ContactTel, contactTel);
  }

  /*officePhone:String*/
  setParamByOfficePhone(officePhone) {
    this.addParameter(this._QueryAttr_OfficePhone, officePhone);
  }

  /*zipCode:String*/
  setParamByZipCode(zipCode) {
    this.addParameter(this._QueryAttr_ZipCode, zipCode);
  }

  /*faxNumbers:String[]*/
  setParamByFaxNumber_Enum(faxNumbers) {
    this.addParameterByEnum(this._QueryAttr_FaxNumber, faxNumbers);
  }

  /*officePhones:String[]*/
  setParamByOfficePhone_Enum(officePhones) {
    this.addParameterByEnum(this._QueryAttr_OfficePhone, officePhones);
  }

  /*masterTels:String[]*/
  setParamByMasterTel_Enum(masterTels) {
    this.addParameterByEnum(this._QueryAttr_MasterTel, masterTels);
  }

  /*startDate:Date, endDate:Date*/
  setParamByFoundedTime_Range(startDate, endDate) {
    this.addDateParameterByRange(this._QueryAttr_FoundedTime, startDate, endDate);
  }

  /*foundedTime:Date*/
  setParamByFoundedTime(foundedTime) {
    this.addParameter(this._QueryAttr_FoundedTime, foundedTime);
  }

  /*startDate:Date, endDate:Date*/
  setParamByExpirationTime_Range(startDate, endDate) {
    this.addDateParameterByRange(this._QueryAttr_ExpirationTime, startDate, endDate);
  }

  /*tenures:String[]*/
  setParamByTenure_Enum(tenures) {
    this.addParameterByEnum(this._QueryAttr_Tenure, tenures);
  }

  /*expirationTime:Date*/
  setParamByExpirationTime(expirationTime) {
    this.addParameter(this._QueryAttr_ExpirationTime, expirationTime);
  }

  /*deputyDirectorName:String*/
  setParamByDeputyDirectorName(deputyDirectorName) {
    this.addParameter(this._QueryAttr_DeputyDirectorName, deputyDirectorName);
  }

  /*masterIdentitys:String[]*/
  setParamByMasterIdentity_Enum(masterIdentitys) {
    this.addParameterByEnum(this._QueryAttr_MasterIdentity, masterIdentitys);
  }

  /*masterTel:String*/
  setParamByMasterTel(masterTel) {
    this.addParameter(this._QueryAttr_MasterTel, masterTel);
  }

  /*masterIdentity:String*/
  setParamByMasterIdentity(masterIdentity) {
    this.addParameter(this._QueryAttr_MasterIdentity, masterIdentity);
  }

  /*streetOfficeCodes:String[]*/
  setParamByStreetOfficeCode_Enum(streetOfficeCodes) {
    this.addParameterByEnum(this._QueryAttr_StreetOfficeCode, streetOfficeCodes);
  }

}